var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","clipped-left":"","color":"white","elevate-on-scroll":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$emit('toggleNav')}}}),_c('app-logo-wrapper'),_c('v-spacer'),_c('app-user')],1)}
var staticRenderFns = []

export { render, staticRenderFns }